export default __webpack_public_path__ + "static/media/44.c5a38490.jpg";